"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _curry = _interopRequireDefault(require("curry"));
var find = (0, _curry.default)(function (fn, data) {
  if (!data) return;
  if (Array.isArray(data)) return data.find(fn);
  var objectKeys = Object.keys(data);
  for (var _i = 0, _objectKeys = objectKeys; _i < _objectKeys.length; _i++) {
    var key = _objectKeys[_i];
    if (fn(data[key], key, data)) {
      return (0, _defineProperty2.default)({}, key, data[key]);
    }
  }
});
var _default = find;
exports.default = _default;